import { render, staticRenderFns } from "./AddVulnerability.vue?vue&type=template&id=2287a062"
import script from "./AddVulnerability.vue?vue&type=script&lang=js"
export * from "./AddVulnerability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports